// extracted by mini-css-extract-plugin
export default {"container":"DynamicText_container__QgIhJ","left":"DynamicText_left__g3A2n","right":"DynamicText_right__UJ3NO"};